import {
  ComponentParams,
  ComponentRendering,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { CtaInlineMediaCards } from '@ahc-digital/component-library';
import { CreateC34InlineMediaCtaModel } from './C34InlineMediaCta.service';
import { translationClasses } from '@/shared/TranslationClasses';
import { SwitchToPreviewMessage } from '@/shared/SwitchToPreviewMessage';

interface C34InlineMediaCtaProps {
  rendering: ComponentRendering & { params: ComponentParams };
  params: ComponentParams;
}

const Default = (props?: C34InlineMediaCtaProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <CtaInlineMediaCards
          {...CreateC34InlineMediaCtaModel(props)}
          id={props?.params?.AnchorLinkTargetName}
          className={translationClasses(props?.params)}
          data-component={marketingRenderingName}
        />
      </SwitchToPreviewMessage>
    );
  }
  return (
    <CtaInlineMediaCards
      {...CreateC34InlineMediaCtaModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C34InlineMediaCtaProps>(Default);
